
export type GetProfileByUsername401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
